import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import FormPreview from '../../components/form-builder/FormPreview';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Paper,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Button
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
  Person as PersonIcon
} from '@mui/icons-material';

const UserForm = () => {
  const { formId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // Redux'tan kullanıcı bilgilerini al
  const userData = useSelector((state) => {
    const reduxData = state?.loginData?.loginData;

    if (!reduxData || !reduxData.id) {
      // Önce form kullanıcısı verilerini kontrol et
      const formUserData = localStorage.getItem('formUserData');
      if (formUserData) {
        try {
          return JSON.parse(formUserData);
        } catch (error) {
          console.error('Error parsing localStorage formUserData:', error);
        }
      }

      // Eğer form kullanıcısı verisi yoksa, panel kullanıcısı verilerini kontrol et
      const localUserData = localStorage.getItem('userData');
      if (localUserData) {
        try {
          return JSON.parse(localUserData);
        } catch (error) {
          console.error('Error parsing localStorage userData:', error);
        }
      }
    }

    return reduxData;
  });

  // Form gönderme işlemi
  const handleFormSubmit = async (formData) => {
    setSubmitting(true);
    setError(null);

    try {
      // Kullanıcı bilgilerini al
      const userInfo = {
        id: userData?.id,
        name: userData?.userData?.name || userData?.username || 'Kullanıcı',
        email: userData?.userData?.email || userData?.username || '',
        categories: userData?.userData?.categories,
        isActive: userData?.userData?.isActive !== false,
        token: userData?.userData?.token || userData?.token
      };

      // Form verilerini hazırla
      const submissionData = {
        formId: formId.toString(),
        formContent: {
          id: parseInt(formId),
          title: formData.title,
          description: formData.description,
          fields: formData.fields,
          formData: formData.formData,
          settings: formData.settings
        },
        formData: {
          formId: formId.toString(),
          formData: formData.formData
        },
        userId: userInfo.id || 0,
        user: userInfo.name || userInfo.email || 'Kullanıcı' // Kullanıcı adını string olarak gönder
      };

      console.log('Gönderilecek veri:', submissionData);

      const response = await axios.post(
        'https://app.hhoms.com/api/form/LibraryRecords',
        submissionData,
        {
          headers: {
            'Content-Type': 'application/json',
            'ApplicationToken': "7db7cfd1-6ea2-487d-8f0a-a830e31eff94"
          }
        }
      );

      if (response.status === 200) {
        console.log('Form başarıyla gönderildi:', response.data);
        setSubmitSuccess(true);

        // 3 saniye sonra dashboard'a yönlendir
        setTimeout(() => {
          // navigate('/user-dashboard');
          if (typeof userData == "object" && Object.keys(userData).length > 0) {
            navigate('/user-dashboard');
          } else {
            location.reload();
          }
          console.log(userData)
        }, 3000);
      }
    } catch (error) {
      console.error('Form gönderme hatası:', error);
      setError('Form gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchFormData = async () => {
      try {
        // Önce localStorage'dan form içeriğini kontrol et
        const storedFormContent = localStorage.getItem('currentFormContent');
        const storedFormId = localStorage.getItem('currentFormId');

        let formContent = null;

        if (storedFormContent && storedFormId === formId) {
          // localStorage'dan al
          try {
            formContent = JSON.parse(storedFormContent);
            console.log('Form içeriği localStorage\'dan alındı');
          } catch (error) {
            console.error('localStorage form içeriği parse edilemedi:', error);
          }
        }

        // localStorage'da yoksa API'den çek
        if (!formContent) {
          console.log('Form içeriği API\'den çekiliyor...');
          const response = await axios.get(
            `https://app.hhoms.com/api/form/Libraries/${formId}`,
            {
              headers: {
                'Content-Type': 'application/json',
                'ApplicationToken': "mete"
              }
            }
          );

          console.log('API Response:', response.data);

          if (response.data.formLibraries && response.data.formLibraries[0]) {
            const apiFormContent = response.data.formLibraries[0].formContent;
            try {
              formContent = JSON.parse(apiFormContent);
              console.log('Form içeriği API\'den alındı');
            } catch (error) {
              console.error('API form içeriği parse edilemedi:', error);
              throw new Error('Form içeriği geçersiz format');
            }
          } else {
            throw new Error('Form bulunamadı');
          }
        }

        // Form verilerini işle
        if (formContent) {
          // Hesaplama alanı değerlerini çıkar
          const calculationValues = {};
          formContent.fields.forEach(field => {
            if (field.type === 'calculation' && field.calculationData) {
              calculationValues[field.id] = field.calculationData;
            }
          });

          // Dosya alanlarını kontrol et ve düzenle
          if (formContent.fields) {
            formContent.fields = formContent.fields.map(field => {
              if (field.type === 'file' || field.type === 'image') {
                return {
                  ...field,
                  accept: field.type === 'image'
                    ? 'image/jpeg,image/png,image/gif,image/webp,image/bmp,image/tiff'
                    : '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip,.rar,.7z',
                  maxSize: 1024 * 1024 * 1024 // 1GB
                };
              }
              return field;
            });
          }

          setFormData({
            ...formContent,
            calculationValues
          });

          console.log('Form verileri yüklendi:', formContent);
        } else {
          throw new Error('Form içeriği bulunamadı');
        }
      } catch (err) {
        console.error('Form yüklenirken bir hata oluştu:', err);
        setError(err.message || 'Form yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchFormData();
  }, [formId]);

  const handleBack = () => {
    navigate('/user-dashboard');
  };

  const handleHome = () => {
    navigate('/user-dashboard');
  };

  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Form yükleniyor...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button variant="contained" onClick={handleBack}>
          Geri Dön
        </Button>
      </Box>
    );
  }

  if (submitSuccess) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: 2
      }}>
        <Alert severity="success" sx={{ mb: 2 }}>
          Form başarıyla gönderildi! Dashboard'a yönlendiriliyorsunuz...
        </Alert>
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* Header */}
      {typeof userData == "object" && Object.keys(userData).length > 0 ? (<AppBar position="static" sx={{ background: 'white', color: 'black' }}>
        <Toolbar>
          <IconButton edge="start" onClick={handleBack} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>

          <Typography variant="h6" sx={{ flex: 1 }}>
            {formData?.title || 'Form'}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton onClick={handleHome}>
              <HomeIcon />
            </IconButton>
            {userData && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonIcon sx={{ fontSize: 20 }} />
                <Typography variant="body2">
                  {userData.userData?.name || userData.username}
                </Typography>
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>) : null}


      {/* Form Content */}
      <Container maxWidth="md" sx={{ py: 3 }}>
        <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          {formData && (
            <FormPreview
              id="user-form-preview"
              formTitle={formData.title}
              formDescription={formData.description}
              formFields={formData.fields}
              settings={formData.settings}
              logoUrl={formData.logo}
              calculationValues={formData.calculationValues}
              onSubmit={handleFormSubmit}
              submitting={submitting}
            />
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default UserForm; 